import React from 'react';
import { Space } from 'antd';
import * as S from '../../styles';

interface BaseModalProps {
	visible?: boolean;
	onCancel: () => void;
	title?: JSX.Element | string;
	width?: number;
	children: React.ReactNode;
	footer?: React.ReactNode;
	centered?: boolean;
}

export function BaseModal({
	visible = false,
	onCancel,
	title,
	width = 400,
	children,
	footer,
	centered = true
}: Readonly<BaseModalProps>) {
	return (
		<S.CustomModal
			title={title}
			open={visible}
			onCancel={onCancel}
			width={width}
			centered={centered}
			footer={footer}
			bodyStyle={{ padding: '24px 32px 32px 32px' }}
		>
			<Space direction="vertical" size={24} style={{ width: '100%' }}>
				{children}
			</Space>
		</S.CustomModal>
	);
}
